import numeral from 'numeral';

class Invoice {
  constructor(data) {
    this.data = data;
    this.lines = [];
    this.adjuster_rates = data.adjuster_rates;

    this.resetFeeScheduleData();

    let _this = this;

    data.invoice.lines.forEach(function(item, index, array) {
      _this.addLine(new InvoiceLine(item));
    });
  }

  resetFeeScheduleData(fee_schedule_data) {

    let original = true;

    if (fee_schedule_data !== undefined) {
      original = false;
      this.data.fee_schedule = fee_schedule_data;
    }

    let data = this.data;

    this.fees = [];

    let _this = this;
    let fees = data.fee_schedule.fees;
    let isNewInvoice = !document.getElementById('invoice_id').value.length;

    data.invoice.fees.forEach(function(invoice_fee, index, array) {
      let fee = fees.find(function(item, index, array) {
        return item.uuid == invoice_fee.uuid;
      });
      if (fee !== undefined) {
        fee.quantity = invoice_fee.quantity;
        fee.selected = true;
      }
      else if (original) {
        invoice_fee.selected = true;
        fees.push(invoice_fee);
      }
    });

    fees.sort(function(a, b) {
      return a.name.localeCompare(b.name);
    });

    fees.forEach(function(item, index, array) {
      if (!isNewInvoice && item.selected === undefined) item.selected = false;
      _this.addFee(new InvoiceFee(item));
    });
  }

  getLine(uuid) {
    return this.lines.find(function(item, index, array) {
      return item.uuid == uuid;
    });
  }

  addLine(line) {
    this.lines.push(line);
    return this.lines.length - 1;
  }

  removeLine(uuid) {
    let ix = this.lines.findIndex(function(item, index, array) {
      return item.uuid == uuid;
    });

    if (ix !== -1) {
      this.lines.splice(ix, 1);
    }
  }

  addFee(fee) {
    this.fees.push(fee);
    return this.fees.length - 1;
  }

  removeFee(uuid) {
    let ix = this.fees.findIndex(function(item, index, array) {
      return item.uuid == uuid;
    });

    if (ix !== -1) {
      this.fees.splice(ix, 1);
    }
  }
}

class InvoiceLine {
  constructor(data) {
    if (data === undefined) data = {};

    this.original = {};
    this.is_new = !!data.is_new;

    if (data.errors !== undefined) {
      this.errors = data.errors;
    }

    this.uuid = this.original.uuid = data.uuid || uuid.v4();
    this.name = this.original.name = data.name;
    this.amount = this.original.amount = data.amount;
    this.bill_to_client = this.original.bill_to_client = data.bill_to_client;
    this.bill_by_adjuster = this.original.bill_by_adjuster = data.bill_by_adjuster;
    this.taxable = this.original.taxable = data.taxable;
  }

  hasError(key) {
    return (this.errors !== undefined) && this.errors[key];
  }

  isDirty(data) {
    let dirty = false;

    data.amount = parseFloat(data.amount);

    for (const prop in data) {
      if (data[prop] != this.original[prop]) {
        dirty = true;
        break;
      }
    }

    return dirty;
  }
}

class InvoiceFee {
  constructor(data) {
    if (data === undefined) data = {};

    this.original = {};
    this.is_new = !!data.is_new;

    this.uuid = this.original.uuid = data.uuid || uuid.v4();
    this.name = this.original.name = data.name || '';
    this.type = this.original.type = data.type || 'fixed';
    this.rate = this.original.rate = data.rate;
    this.adjuster_rate = this.original.adjuster_rate = data.adjuster_rate;
    this.included = this.original.included = data.included || 0;
    this.quantity = this.original.quantity = data.quantity || 0;
    this.taxable = this.original.taxable = data.taxable || false;
    this.discountable = this.original.discountable = data.discountable || false;
    this.default = this.original.default = data.default || false;
    this.selected = this.original.selected = (data.selected ?? data.default) || false;
    this.adjuster_payout = data.adjuster_payout || {type: 'default'};
    this.original['adjuster_payout.type'] = this.adjuster_payout.type;
    this.original['adjuster_payout.rate'] = this.adjuster_payout.rate;
  }

  isDirty(data) {
    let dirty = false;

    data.rate = parseFloat(data.rate);
    data.adjuster_rate = parseFloat(data.adjuster_rate);
    data.included = parseFloat(data.included);
    data.taxable = !!parseInt(data.taxable);
    data.discountable = !!parseInt(data.discountable);
    data.default = !!parseInt(data.default);
    data['adjuster_payout.rate'] = parseFloat(data['adjuster_payout.rate']);

    for (const prop in data) {
      if (data[prop] != this.original[prop]) {
        if (prop === 'adjuster_payout.rate' && data['adjuster_payout.type'] !== 'custom') continue;
        dirty = true;
        break;
      }
    }

    return dirty;
  }

  summary() {
    let summary = '';
    summary += 'Rate: ' + numeral(this.rate).format('$0,0.[000]');

    if (this.adjuster_rate) {
      summary += '/' + numeral(this.adjuster_rate).format('$0,0.[000]');
    }

    if (this.type == 'per_unit') {
      summary += '/unit';
      if (this.included) {
        summary += '; Included: ' + this.included;
      }
    }

    if (this.discountable) {
      summary += '; Discountable';
    }

    summary += '; Adjuster\'s share: ';
    if (this.adjuster_payout.type === 'none') {
      summary += '0%';
    }
    else if (this.adjuster_payout.type === 'all') {
      summary += '100%';
    }
    else if (this.adjuster_payout.type === 'default') {
      summary += 'default';
    }
    else if (this.adjuster_payout.type === 'custom') {
      summary += '$' + this.adjuster_payout.rate;
      if (this.type === 'per_unit') {
        summary += '/unit';
      }
    }


    return summary;
  }
}

export {InvoiceFee, InvoiceLine, Invoice};

